import React from "react";
import { Box } from "@chakra-ui/react";
import { AutoComplete, Form } from "components";
import { NURSE_ROLES, useCurrentCase } from "duck";
import { UserRoleEnum } from "requests";
import { getValidation, useUpdateMonitoring } from "./duck";

const Doctors: React.FC = () => {
  const monitoringData = useCurrentCase(
    medicalCase => medicalCase.data.client.patient.monitoring
  );
  const monitoringById = monitoringData?.monitoringBy?._id || null;

  const validation = React.useMemo(() => getValidation(monitoringById), [
    monitoringById
  ]);
  const onChange = useUpdateMonitoring(monitoringData._id);

  const userRoles = [...NURSE_ROLES, UserRoleEnum.RoleAnesthetist];

  return (
    <Form {...validation}>
      <Form.Watcher
        defaultValues={validation.defaultValues}
        onChange={onChange}
      />
      <Box minW="240px">
        <AutoComplete.Users
          label="Monitoring by"
          name="doctor"
          placeholder="Select nurse"
          role={userRoles}
        />
      </Box>
    </Form>
  );
};

export default Doctors;
